import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { adminMainUrl } from '../../../../../Config';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getJobOrderCustomerList, getJobOrderEntityDetails } from '../../../../../Redux/action/Joborder/JoborderAction';
import Beatloader from '../../../../../Common/Loaders/Beatloader';


const EntityTab = ({ token, user_id, b64id }) => {
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [showExtraEntity, setShowExtraEntity] = useState(true);
    const [showCustomBroker, setShowCustomBroker] = useState(true);
    const [showSecondNotify, setShowSecondNotify] = useState(true);
    const [showThirdNotify, setShowThirdNotify] = useState(true);
    const [showTransporter, setShowTransporter] = useState(true);
    const [showShipTo, setShowShipTo] = useState(true);
    const [showBookingParty, setShowBookingParty] = useState(true);
    const [showSeller, setShowSeller] = useState(true);
    const [showImporter, setShowImporter] = useState(true);
    const [showBuyer, setShowBuyer] = useState(true);


    useEffect(() => {
        if (token && user_id) {
            dispatch(getJobOrderCustomerList(token, user_id));
            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getJobOrderEntityDetails(token, user_id, id));
                }
            }
        }
    }, [token, user_id, b64id]);


    const refreshEntityData = () => {
        if (token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getJobOrderEntityDetails(token, user_id, id));
            }

        }
    }

    let {
        loadingJobOrderCustomerList,
        JobOrderCustomerList,
        JobOrderCustomerListError,

        loadingJobOrderEntityDetail,
        JobOrderEntityDetailError,
        JobOrderEntityDetail,
    } = useSelector(state => state?.JoborderReducer);






    let [loadingCompany, setLoadingCompany] = useState(false);
    let [shipperOptions, setShipperOptions] = useState([]);
    let [consigneeOptions, setConsigneeOptions] = useState([]);
    let [agentOptions, setAgentOptions] = useState([]);
    let [customerOptions, setCustomerOptions] = useState([]);

    useEffect(() => {
        if (loadingJobOrderCustomerList) {
            setLoadingCompany(true);
        } else {
            setLoadingCompany(false);
        }

        if (JobOrderCustomerList) {
            let arr = [];
            JobOrderCustomerList.map((val) => { arr.push({ value: val.id, label: val.name }) });
            setCustomerOptions(arr);

            let shipperArr = [];
            JobOrderCustomerList.map(val => {
                if (val.entity_type) {
                    let parsed = JSON.parse(val.entity_type);
                    if (Array.isArray(parsed)) {
                        if (parsed.includes("shipper")) {
                            shipperArr.push({ value: val.id, label: val.name })
                        }
                    }
                }
            });
            setShipperOptions(shipperArr);

            let consigneeArr = [];
            JobOrderCustomerList.map(val => {
                if (val.entity_type) {
                    let parsed = JSON.parse(val.entity_type);
                    if (Array.isArray(parsed)) {
                        if (parsed.includes("consignee")) {
                            consigneeArr.push({ value: val.id, label: val.name })
                        }
                    }
                }
            });
            setConsigneeOptions(consigneeArr);
            let agentArr = [];
            JobOrderCustomerList.map(val => {
                if (val.entity_type) {
                    let parsed = JSON.parse(val.entity_type);
                    if (Array.isArray(parsed)) {
                        if (parsed.includes("agent")) {
                            agentArr.push({ value: val.id, label: val.name })
                        }
                    }
                }
            });
            setAgentOptions(agentArr);
        }
    }, [loadingJobOrderCustomerList, JobOrderCustomerList])


    useEffect(() => {
        if (showCustomBroker == true || showSecondNotify == true || showThirdNotify == true || showTransporter == true || showShipTo == true || showBookingParty == true || showSeller == true || showImporter == true || showBuyer == true) {
            setShowExtraEntity(true);
        } else {
            setShowExtraEntity(false);
        }
    }, [showCustomBroker, showSecondNotify, showThirdNotify, showTransporter, showShipTo, showBookingParty, showSeller, showImporter, showBuyer])


    // const shipperOptions = [
    //     { value: 1, label: "Rohit" },
    //     { value: 2, label: "Ravi" },
    //     { value: 3, label: "Sakshi" },
    //     { value: 4, label: "Abhishek" },
    //     { value: 5, label: "Shweta" },
    // ];


    const initialValues = {
        job_order_id: "",
        shipper_customer_id: "",
        consignee_customer_id: "",
        origin_agent_id: "",
        destination_agent_id: "",
        notify_customer_id: "",
        consigned_to_bank: "",
        customs_broker_id: "",
        second_notify_id: "",
        third_notify_id: "",
        transporter_id: "",
        ship_to_id: "",
        booking_party_id: "",
        seller_id: "",
        importer_id: "",
        buyer_id: "",
    };


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.job_order_id = atob(b64id);

                if (!values.shipper_customer_id) { values.shipper_customer_id = null }
                if (!values.consignee_customer_id) { values.consignee_customer_id = null }
                if (!values.origin_agent_id) { values.origin_agent_id = null }
                if (!values.destination_agent_id) { values.destination_agent_id = null }
                if (!values.notify_customer_id) { values.notify_customer_id = null }
                if (!values.consigned_to_bank) { values.consigned_to_bank = null }
                if (!values.customs_broker_id) { values.customs_broker_id = null }
                if (!values.second_notify_id) { values.second_notify_id = null }
                if (!values.third_notify_id) { values.third_notify_id = null }
                if (!values.transporter_id) { values.transporter_id = null }
                if (!values.ship_to_id) { values.ship_to_id = null }
                if (!values.booking_party_id) { values.booking_party_id = null }
                if (!values.seller_id) { values.seller_id = null }
                if (!values.importer_id) { values.importer_id = null }
                if (!values.buyer_id) { values.buyer_id = null }

                axios.post(`${adminMainUrl}/api/jobOrder/entity/add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refreshEntityData();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (loadingJobOrderEntityDetail) {
            setShowLoader(true)
        } else {
            setShowLoader(false)
        };

        if (JobOrderEntityDetail) {

            if (JobOrderEntityDetail?.customs_broker_id) { setShowCustomBroker(true) } else { setShowCustomBroker(false) }
            if (JobOrderEntityDetail?.second_notify_id) { setShowSecondNotify(true) } else { setShowSecondNotify(false) }
            if (JobOrderEntityDetail?.third_notify_id) { setShowThirdNotify(true) } else { setShowThirdNotify(false) }
            if (JobOrderEntityDetail?.transporter_id) { setShowTransporter(true) } else { setShowTransporter(false) }
            if (JobOrderEntityDetail?.ship_to_id) { setShowShipTo(true) } else { setShowShipTo(false) }
            if (JobOrderEntityDetail?.booking_party_id) { setShowBookingParty(true) } else { setShowBookingParty(false) }
            if (JobOrderEntityDetail?.seller_id) { setShowSeller(true) } else { setShowSeller(false) }
            if (JobOrderEntityDetail?.importer_id) { setShowImporter(true) } else { setShowImporter(false) }
            if (JobOrderEntityDetail?.buyer_id) { setShowBuyer(true) } else { setShowBuyer(false) }


            formik.setFieldValue("shipper_customer_id", Number(JobOrderEntityDetail?.shipper_customer_id));
            formik.setFieldValue("consignee_customer_id", Number(JobOrderEntityDetail?.consignee_customer_id));
            formik.setFieldValue("origin_agent_id", Number(JobOrderEntityDetail?.origin_agent_id));
            formik.setFieldValue("destination_agent_id", Number(JobOrderEntityDetail?.destination_agent_id));
            formik.setFieldValue("notify_customer_id", Number(JobOrderEntityDetail?.notify_customer_id));
            formik.setFieldValue("consigned_to_bank", Number(JobOrderEntityDetail?.consigned_to_bank));
            formik.setFieldValue("customs_broker_id", Number(JobOrderEntityDetail?.customs_broker_id));
            formik.setFieldValue("second_notify_id", Number(JobOrderEntityDetail?.second_notify_id));
            formik.setFieldValue("third_notify_id", Number(JobOrderEntityDetail?.third_notify_id));
            formik.setFieldValue("transporter_id", Number(JobOrderEntityDetail?.transporter_id));
            formik.setFieldValue("ship_to_id", Number(JobOrderEntityDetail?.ship_to_id));
            formik.setFieldValue("booking_party_id", Number(JobOrderEntityDetail?.booking_party_id));
            formik.setFieldValue("seller_id", Number(JobOrderEntityDetail?.seller_id));
            formik.setFieldValue("importer_id", Number(JobOrderEntityDetail?.importer_id));
            formik.setFieldValue("buyer_id", Number(JobOrderEntityDetail?.buyer_id));
        }

    }, [loadingJobOrderEntityDetail, JobOrderEntityDetailError, JobOrderEntityDetail,]);

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };

    return (

        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row border-bottom-2 pb-3">
                                <div className="col-md-12">
                                    <div className=" py-2">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center " >
                                                        <label htmlFor="Shipper" className='form-label mx-2'>Shipper:</label>
                                                        <Select
                                                            id="Shipper"
                                                            className='mt-2 custom-selector w-100'
                                                            options={shipperOptions}
                                                            styles={customStyles}
                                                            name="shipper_customer_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('shipper_customer_id', option.value);
                                                            }}
                                                            value={shipperOptions.find(option => option.value === formik.values.shipper_customer_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="Consignee" className='form-label mx-2'>Consignee:</label>
                                                        <Select
                                                            id="Consignee"
                                                            className='mt-2 custom-selector w-100'
                                                            options={consigneeOptions}
                                                            styles={customStyles}
                                                            name="consignee_customer_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('consignee_customer_id', option.value);
                                                            }}
                                                            value={consigneeOptions.find(option => option.value === formik.values.consignee_customer_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="OriginAgent" className='form-label mx-2'>Origin Agent:</label>
                                                        <Select
                                                            id="OriginAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={agentOptions}
                                                            styles={customStyles}
                                                            name="origin_agent_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('origin_agent_id', option.value);
                                                            }}
                                                            value={agentOptions.find(option => option.value === formik.values.origin_agent_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Destination Agent:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={agentOptions}
                                                            styles={customStyles}
                                                            name="destination_agent_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('destination_agent_id', option.value);
                                                            }}
                                                            value={agentOptions.find(option => option.value === formik.values.destination_agent_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Notify:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="notify_customer_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('notify_customer_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.notify_customer_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Consigned to Bank:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="consigned_to_bank"
                                                            onChange={option => {
                                                                formik.setFieldValue('consigned_to_bank', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.consigned_to_bank) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-6">
                                    <div className="card">
                                        <div className="d-flex p-3 align-items-center">
                                            <label htmlFor="DestinationAgent" className='form-label mx-2'>Customer:</label>
                                            <Select
                                                id="DestinationAgent"
                                                className='mt-2 custom-selector w-100'
                                                options={customerOptions}
                                                name="customer_id"
                                                onChange={option => {
                                                    formik.setFieldValue('customer_id', option.value);
                                                }}
                                                value={customerOptions.find(option => option.value === formik.values.customer_id) || null}
                                            />
                                        </div>
                                    </div>
                                </div> */}

                                        </div>
                                        {/* <div className>
                                            <label htmlFor="" className="form-label">Add/Remove Entity:</label>
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <input type="checkbox" className="mx-2" name="Customs Broker" id="Customs Broker" onChange={(e) => { setShowCustomBroker(e.target.checked) }} />
                                                    <label htmlFor="Customs Broker" className="form-label">Customs Broker</label>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="checkbox" className="mx-2" name="Second Notify" id="Second Notify" onChange={(e) => { setShowSecondNotify(e.target.checked) }} />
                                                    <label htmlFor="Second Notify" className="form-label">Second Notify</label>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="checkbox" className="mx-2" name="Third Notify" id="Third Notify" onChange={(e) => { setShowThirdNotify(e.target.checked) }} />
                                                    <label htmlFor="Third Notify" className="form-label">Third Notify</label>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="checkbox" className="mx-2" name="Transporter" id="Transporter" onChange={(e) => { setShowTransporter(e.target.checked) }} />
                                                    <label htmlFor="Transporter" className="form-label">Transporter</label>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="checkbox" className="mx-2" name="Ship to" id="Ship to" onChange={(e) => { setShowShipTo(e.target.checked) }} />
                                                    <label htmlFor="Ship to" className="form-label">Ship to</label>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="checkbox" className="mx-2" name="Booking Party" id="Booking Party" onChange={(e) => { setShowBookingParty(e.target.checked) }} />
                                                    <label htmlFor="Booking Party" className="form-label">Booking Party</label>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="checkbox" className="mx-2" name="Seller" id="Seller" onChange={(e) => { setShowSeller(e.target.checked) }} />
                                                    <label htmlFor="Seller" className="form-label">Seller</label>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="checkbox" className="mx-2" name="Importer" id="Importer" onChange={(e) => { setShowImporter(e.target.checked) }} />
                                                    <label htmlFor="Importer" className="form-label">Importer</label>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="checkbox" className="mx-2" name="Buyer" id="Buyer" onChange={(e) => { setShowBuyer(e.target.checked) }} />
                                                    <label htmlFor="Buyer" className="form-label">Buyer</label>
                                                </div>
                                            </div>
                                        </div> */}

                                        {showExtraEntity && <div className="row">
                                            {showCustomBroker && <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Customs Broker:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="customs_broker_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('customs_broker_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.customs_broker_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}

                                            {showSecondNotify && <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Second Notify:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="second_notify_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('second_notify_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.second_notify_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                            {showThirdNotify && <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Third Notify:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="third_notify_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('third_notify_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.third_notify_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                            {showTransporter && <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Transporter:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="transporter_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('transporter_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.transporter_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                            {showShipTo && <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Ship to:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="ship_to_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('ship_to_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.ship_to_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                            {showBookingParty && <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Booking Party:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="booking_party_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('booking_party_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.booking_party_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                            {showSeller && <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Seller:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="seller_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('seller_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.seller_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                            {showImporter && <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Importer:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="importer_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('importer_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.importer_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                            {showBuyer && <div className="col-md-6">
                                                <div className="card">
                                                    <div className="d-flex p-3 align-items-center">
                                                        <label htmlFor="DestinationAgent" className='form-label mx-2'>Buyer:</label>
                                                        <Select
                                                            id="DestinationAgent"
                                                            className='mt-2 custom-selector w-100'
                                                            options={customerOptions}
                                                            styles={customStyles}
                                                            name="buyer_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('buyer_id', option.value);
                                                            }}
                                                            value={customerOptions.find(option => option.value === formik.values.buyer_id) || null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>}
                                    </div>
                                </div>

                            </div>
                            <div className="row d-flex justify-content-end my-2">
                                <div className="col-md-6 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                        {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </>
            }
        </>

    )
}

export default EntityTab